import React, { useState, useRef, useContext } from "react";
import { Form, Input, Button, Row, Col, Drawer, message } from 'antd';

import AddSetupDetails from "modules/system_setup/add_system_setup_values/addSetupDetails";
import { searchMessagesAPI } from "services/system_setup/message_prompt";
import { searchRolesAPI } from "services/system_setup/roles";
import { searchModulesAPI } from "services/system_setup/modules";
import { searchAccessTypesAPI } from "services/system_setup/access_types";
import { searchModuleAccessAPI } from "services/system_setup/module_access";
import { UserAccessContext } from "context/userAccess";

function SearchSetupForm(props) {
    const [form] = Form.useForm();
    const { userAccess } = useContext(UserAccessContext);
    const createRight = userAccess['systemSetup'].create;

    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };
    const onClose = () => { setOpen(false); };
    
    const formRef = useRef();

    function drawerClose(value) {
        setOpen(value);
    }

    function refreshTblData(values) {
        if(values){
            handleSubmit({searchValue:''});
        }
    };

    async function handleSubmit(formValues){
        try {

            if(props.addButton === 'MESSAGE PROMPTS'){
                const response = await searchMessagesAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'ROLES'){
                const response = await searchRolesAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'MODULES'){
                console.log('formValues.searchValue', formValues.searchValue)
                const response = await searchModulesAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'ACCESS TYPES'){
                console.log('formValues.searchValue', formValues.searchValue)
                const response = await searchAccessTypesAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }

            if(props.addButton === 'MODULE ACCESS'){
                console.log('formValues.searchValue', formValues.searchValue)
                const response = await searchModulesAPI(formValues.searchValue)
                props.onFinish(response);

                if(response.length <= 0){
                    message.info('No results found');
                }
            }
            
        } catch (error) {
            console.log('try submit search error', error)
        }
    };

    return(
        <div>
            <Form 
                form={form}
                layout="vertical" 
                onFinish={handleSubmit}
                ref={formRef}
            >
            <Row gutter={[8, 1]} align='bottom'>
                <Col className="gutter-row" span={6} >
                    <Form.Item name='searchValue'>
                        <Input placeholder={props.placeholder} 
                            className='inv-input-uppercase'
                        />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={6} >
                    <Form.Item>
                        <Button
                            className="login-form-button"
                            type="primary"
                            htmlType='submit'
                        >
                            Search
                        </Button>
                        {/* <Button style={{ marginLeft: '5px' }} >
                            Clear
                        </Button> */}
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12} >
                    {(props.addButton!=='MODULE ACCESS')
                        ?   (createRight === 'TRUE')
                            ?   <Form.Item>
                                    <Button style={{ float:'right' }} 
                                        type="primary"
                                        onClick={showDrawer}
                                    >
                                        ADD {props.addButton}
                                    </Button>
                                        <Drawer title={"ADD " + props.addButton} placement="right" onClose={onClose}
                                            width="30%"
                                            visible={open}
                                            destroyOnClose
                                        >
                                            <AddSetupDetails 
                                                setupDet={props.addButton} 
                                                drawerClose={ drawerClose } 
                                                refreshTblData={ refreshTblData }
                                                drawerValue={open}
                                                action='ADD'
                                            />
                                        </Drawer>
                                </Form.Item>
                            :   <></>
                        : <></>
                    }
                </Col>
            </Row>
            </Form>
        </div>
    )
}

export default SearchSetupForm;